import Spin from 'antd/lib/spin';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';

const LoadingPage = function LoadingPage() {
  const antIcon = <LoadingOutlined spin />;

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Spin size='large' indicator={antIcon} />
    </div>
  );
};

export default LoadingPage;
